import { Box, Stack, Button, Snackbar, Alert, Divider } from "@mui/material";
import React, { useState, useEffect } from "react";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { InvokeAPI } from "../../apis/API";
import { getInternalMgmtBase } from "../../config/apiBase";
import { useAuth } from "../../contexts/AuthContext";

const FeedbackAction = () => {
    const { user, logout } = useAuth();
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };


    const [feedback, setFeedback] = useState([])

    const getFeedback = async () => {
        const feedback = await InvokeAPI(`${getInternalMgmtBase()}/v1/user/feedback/get`,
            {
                "ID": "",
            },
            'POST',
            {},
            false)
        return feedback.response.Feedbacks
    }

    useEffect(() => {
        getFeedback().then(data => setFeedback(data));
    }, []);
    console.log(feedback)
    return (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ "paddingTop": "50px" }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Stack>
                {feedback.map((row) => (
                    <>
                    {row.ID} &nbsp; &nbsp; {row.Feedback}
                    <br></br>
                    Response: {row.Response}
                    <br></br>
                    UserID : {row.UserID}
                    <Divider sx={{paddingBottom: "10px"}}></Divider>
                    </>
                ))}

            </Stack>
        </Box>
    )
}

export default FeedbackAction;